import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { PageContent } from '@/components/page-content'
import { PageHeaderSkeleton } from '@/components/skeleton/page-header-skeleton'
import { TableSkeleton } from '@/components/ui/table'
import { organizationsMinimalQueryOptions } from '@/modules/organization/presentation/hooks/useOrganizations'
import { EmailsTemplatesPage } from '@/modules/organization/presentation/pages/EmailsTemplates'

export const Route = createFileRoute('/_authenticated/settings/emails-templates')({
  component: EmailsTemplatesPage,
  head: () => ({
    meta: [
      {
        title: 'Settings : Emails Templates',
      },
    ],
  }),
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(organizationsMinimalQueryOptions),
  loaderDeps: ({ search: { organizationId } }) => ({
    organizationId,
  }),
  pendingComponent: () => (
    <>
      <PageHeaderSkeleton cta title="Organizations" />
      <PageContent>
        <TableSkeleton />
      </PageContent>
    </>
  ),
  validateSearch: z.object({
    organizationId: z.string().optional(),
  }),
})
